<template>
    <div class="card mb-3">
        <div class="card-header border-bottom">
            <i class="fas fa-user me-2"></i>{{TR.profile}} {{TR.update}}
        </div>
        <div class="card-body container p-3">

            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.preview}}</label>
                <div class="col-sm-10">
                    <Image
                        :src="userData.preview_image"
                        :alt="TR.image"
                        height="90"
                        :preview="true"
                    />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.image}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.firstname" /> -->
                    <div class="d-flex flex-md-row flex-column align-items-center">
                        <FileUpload
                            v-model="userData.image"
                            mode="basic"
                            name="images[]"
                            :customUpload="true"
                            @select="onFileChanged($event)"
                            accept="image/*"
                            :multiple="false"
                            :maxFileSize="G.uploadedFileSize"
                            :fileLimit="1"
                            :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                            :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                            :uploadLabel="TR.upload"
                            :chooseLabel="TR.select_file"
                            class="rounded text-nowrap"
                            />
                        <!-- <span class="mx-3 text-nowrap no-break">{{TR.or}}</span>
                        <InputText
                            v-model="userData.image"
                            type="text"
                            class="form-control"
                            placeholder="Faylın linkini daxil edin"
                            @change="onImageChanged($event)"
                        /> -->
                    </div>
                </div>
            </div>

            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.firstname}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.lastname" /> -->
                    <InputText v-model="userData.firstname" class="form-control" type="text" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.lastname}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.lastname" /> -->
                    <InputText v-model="userData.lastname" class="form-control" type="text" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.current_password}}</label>
                <div class="col-sm-10">
                    <!-- <input type="password" class="form-control" v-model="userData.password1" /> -->
                    <InputText v-model="userData.current_password" class="form-control" type="password" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.new_password1}}</label>
                <div class="col-sm-10">
                    <!-- <input type="password" class="form-control" v-model="userData.password1" /> -->
                    <InputText v-model="userData.new_password1" class="form-control" type="password" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.new_password2}}</label>
                <div class="col-sm-10">
                    <!-- <input type="password" class="form-control" v-model="userData.password2" /> -->
                    <InputText v-model="userData.new_password2" class="form-control" type="password" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.email}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.email" /> -->
                    <InputText v-model="userData.email" class="form-control" type="text" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.phone}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.phone" /> -->
                    <InputMask v-model="userData.phone" class="form-control" mask="+999 (99) 999-99-99" placeholder="+999 (99) 999-99-99" />
                </div>
            </div>
            <div class="row mb-3">
                <label class="col-sm-2 col-form-label" for="basic-default-name">{{TR.about}}</label>
                <div class="col-sm-10">
                    <!-- <input type="text" class="form-control" v-model="userData.about" /> -->
                    <Textarea v-model="userData.about" class="form-control" :autoResize="false" rows="3" cols="20" />
                </div>
            </div>

            <div class="row justify-content-end">
                <div class="col-sm-10">
                    <button type="button" class="btn btn-primary" @click="updateUserData"><i class="fas fa-save me-2"></i>{{TR.update}}</button>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    import { onMounted, ref, reactive, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import { useRouter } from "vue-router";

    import { G, ajax } from "@/_common";

    import Image from "primevue/image";
    import FileUpload from "primevue/fileupload";
    import InputText from "primevue/inputtext";
    import InputMask from "primevue/inputmask";
    import Textarea from "primevue/textarea";

    export default {
        title: "profile",
        name: "ProfilePage",
        components:{
            Image,
            FileUpload,
            InputText,
            InputMask,
            Textarea,
        },
        setup() {
            const store = useStore();
            const router = useRouter();
            const TR = ref({});

            const userData = reactive({
                id: '',
                username: '',
                preview_image: '',
                image: '',
                new_image: '',
                firstname: '',
                lastname: '',
                current_password: '',
                new_password1: '',
                new_password2: '',
                email: '',
                phone: '',
                about: '',
            });

            const onFileChanged = (e) => {
                if (e.files.length) {
                    userData.preview_image = e.files[0].objectURL;
                    userData.new_image = e.files[0];
                }
            };

            const onImageChanged = (e) => {
                userData.preview_image = e.target.value;
                userData.image = e.target.value;
            };

            const getUserData = async () => {
                await ajax({
                    url: store.getUsersUpdate(G.token_data().id),
                    success: (e) => {
                        const res = e.data || null;
                        if (res) {
                            userData.id = res.id;
                            userData.username = res.username;
                            userData.preview_image = res.image; // ? res.image : '/assets/images/noimg.png';
                            userData.image = res.image;
                            userData.firstname = res.firstname;
                            userData.lastname = res.lastname;
                            userData.email = res.email;
                            userData.phone = res.phone;
                            userData.about = res.about;
                        }
                    }
                });
            }

            onMounted(async () => {
                await getUserData();
            });

            const updateUserData = async () => {
                let e = userData;
                let ud = G.token_data();

                let formData = new FormData();
                // if( e.image != ud.image && e.image != null && typeof e.image === 'object' ){
                if( e.new_image != '' ){
                    formData.append("upload_image", e.new_image);
                }
                let user_data = {
                    username: e.username,
                    firstname: e.firstname,
                    lastname: e.lastname,
                    email: e.email,
                    phone: e.phone,
                    about: e.about,
                    current_password: e.current_password,
                };
                if( e && e.new_password1 && e.new_password1 != '' && e.new_password1 == e.new_password2 ){
                    user_data.password = e.new_password1;
                }

                if( e.new_image == '' && e.image != null && e.image != '' && e.image != ud.image ){
                    user_data.image = e.image;
                }

                formData.append("data", JSON.stringify(user_data));

                await ajax({
                    url: store.getUsersUpdateProfile(userData.id),
                    method: 'patch',
                    // content_type: 'application/json; charset=UTF-8',
                    data: formData,
                    success: async (x) => {
                        const res = x.data || null;
                        if (res) {
                            if( res.image ){
                                G.userImage.value = res.image
                                G.setClientData("AUTH_TOKEN", res.token);
                            }
                            await getUserData();
                            router.push('/');
                            setTimeout(() => {
                                G.alert.success(TR.value.msg_update_success);
                            }, 500);
                        }
                    },
                    // error: (x) => {
                    //     var res = x.response || {};
                    //     if( res.status == 422 ){
                    //         G.alert.warning(G.getErrorMessages(res.data.detail));
                    //     }
                    //     else
                    //         G.alert.warning(res.data.detail);
                    // }
                });
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
            });

            return {G, TR, userData, updateUserData, onFileChanged, onImageChanged};
        },
    };
</script>

<style lang="scss" scoped>
// .form-control{
//     padding: 8px 10px;
// }
</style>


